/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { useMDSImage } from '../../../utils/mds-context'
import type { CardThumbnailProps } from '../types'
import s from './card-thumbnail.module.css'

export const CardThumbnail = ({
	alt,
	aspectRatio,
	src,
}: CardThumbnailProps) => {
	const Image = useMDSImage()
	return src ? (
		<div
			className={s.thumbnail}
			style={{ ['--aspect-ratio' as string]: aspectRatio }}
		>
			<Image fill alt={alt} src={src} />
		</div>
	) : null
}
